import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { ASSETS } from "./Decorative";

const links = [
    { to: "/", label: "Start", end: true },
    { to: "/speisekarte", label: "Unser Angebot" },
    { to: "/#heute", label: "Heutiges Softeis" },
    { to: "/#fuer-spaeter", label: "Für Später" },
    { to: "/#galerie", label: "Galerie" },
    { to: "/#kontakt", label: "Kontakt" },
];

export const Navbar = () => {
    const [open, setOpen] = useState(false);
    return (
        <header
            className="sticky top-0 z-40 bg-cream/85 backdrop-blur-xl border-b border-cream-dark"
            data-testid="main-navbar"
        >
            <div className="max-w-7xl mx-auto px-5 sm:px-8 py-3 flex items-center justify-between">
                <Link to="/" className="flex items-center gap-3 group" data-testid="navbar-home-link">
                    <div className="w-12 h-12 rounded-full bg-leaf-green/30 grid place-items-center overflow-hidden ring-2 ring-leaf-green/40 group-hover:ring-garden-green transition">
                        <img src={ASSETS.mascot} alt="Eistroll" className="w-11 h-11 object-contain -mt-0.5" />
                    </div>
                    <div className="leading-tight">
                        <div className="font-serif text-xl font-semibold text-deep-green">Softeis Garten</div>
                        <div className="font-cursive text-base text-pastel-pink-dark -mt-1">~ frisch & fröhlich ~</div>
                    </div>
                </Link>

                <nav className="hidden md:flex items-center gap-1">
                    {links.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            end={l.end}
                            data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                            className={({ isActive }) =>
                                `px-4 py-2 rounded-full font-sans font-medium text-deep-green/80 hover:text-deep-green hover:bg-leaf-green/20 transition ${
                                    isActive ? "bg-leaf-green/30 text-deep-green" : ""
                                }`
                            }
                        >
                            {l.label}
                        </NavLink>
                    ))}
                </nav>

                <button
                    className="md:hidden p-2 rounded-full hover:bg-leaf-green/20"
                    onClick={() => setOpen((v) => !v)}
                    aria-label="Menü"
                    data-testid="mobile-menu-toggle"
                >
                    {open ? <X className="w-6 h-6 text-deep-green" /> : <Menu className="w-6 h-6 text-deep-green" />}
                </button>
            </div>

            {open && (
                <div className="md:hidden px-5 pb-4 flex flex-col gap-1 border-t border-cream-dark bg-cream">
                    {links.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            end={l.end}
                            onClick={() => setOpen(false)}
                            data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                            className="px-4 py-3 rounded-2xl font-sans font-medium text-deep-green hover:bg-leaf-green/20"
                        >
                            {l.label}
                        </NavLink>
                    ))}
                </div>
            )}
        </header>
    );
};
